import { NavLink } from 'react-router';

import { FaIcon, NgNotificationBadge, TextWithIcon } from '@/ui';
import { DateFormatter } from '@/features/shared/DateFormatter';
import { incidentDetailRoute } from '@/features/shared/routes';
import { CallNotificationSource } from '@/signalr/contracts';
import type { CallNotificationItem } from '@/signalr/contracts';
import type { CallWithIncidentId } from './incidentListSelectors';

export type CallNotificationListComponentItemProps = {
  item: CallWithIncidentId;
  onCreateNewIncident: (item: CallWithIncidentId) => void | Promise<void>;
};

function sourceName(callNotification: CallNotificationItem): string {
  switch (callNotification.source) {
    case CallNotificationSource.AppleEED:
      return 'Apple EED';
    case CallNotificationSource.AML:
      return 'AML';
    default:
      return '';
  }
}

const LINK_CSS_CLASS =
  'call-notification-item d-flex flex-row justify-content-between align-items-center border-bottom py-1 px-2 text-decoration-none';

export function CallNotificationListComponentItem({
  item,
  onCreateNewIncident,
}: CallNotificationListComponentItemProps) {
  const callNotification = item.callNotification;
  const phoneIcon = callNotification.endTimeUtc != null ? 'fa-light fa-phone-hangup' : 'fa-light fa-phone-volume';

  const content = (
    <div className="d-flex flex-column gap- align-items-stretch col-11">
      <TextWithIcon icon={phoneIcon} cssClass="d-flex align-items-center" contentCssClass="fw-bold">
        {callNotification.callId}
      </TextWithIcon>
      <TextWithIcon icon="fa-light fa-circle-location-arrow">
        <span className="small">
          <NgNotificationBadge noMargin color="darkGray" text={sourceName(callNotification)} />
        </span>
      </TextWithIcon>
      <TextWithIcon icon="fa-light fa-clock">
        <span className="small">
          <DateFormatter date={callNotification.startTimeUtc} updateIntervalMs={1000} formatType="timeCombined" />
        </span>
      </TextWithIcon>
    </div>
  );

  return (
    <div className="call-notification-item-wrapper">
      {item.incidentId != null ? (
        <NavLink
          to={incidentDetailRoute(item.incidentId)}
          className={({ isActive }) => (isActive ? `${LINK_CSS_CLASS} active` : LINK_CSS_CLASS)}
        >
          {content}
          <FaIcon icon="fa-light fa-chevron-right" />
        </NavLink>
      ) : (
        <div
          onClick={() => void onCreateNewIncident(item)}
          className="call-notification-item d-flex flex-row justify-content-between align-items-center border-bottom py-1 px-2"
          style={{ cursor: 'pointer' }}
        >
          {content}
          <FaIcon icon="fa-light fa-plus" />
        </div>
      )}
    </div>
  );
}
